'use client'

import { useCheckout, useModals } from '@/lib/hooks'

import { CustomReference } from '@/components/forms'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui'

interface CustomReferenceModalProps
  extends React.ComponentPropsWithoutRef<'div'> {
  open?: boolean
}

export const CustomReferenceModal = ({ open }: CustomReferenceModalProps) => {
  const { closeModal, closeAll } = useModals()
  const { payment_method } = useCheckout()

  return (
    <Dialog open={open}>
      <DialogContent
        closeOnOverlay
        onClose={() => closeModal('CUSTOM_REFERENCE')}
        size="lg"
      >
        <DialogHeader>
          <DialogTitle>{payment_method?.reference_label ?? 'Custom Reference'}</DialogTitle>
          <DialogDescription>
            Please enter the {payment_method?.reference_label ?? 'custom reference'}
          </DialogDescription>
        </DialogHeader>

        {open && <CustomReference onClose={() => closeAll()} />}
      </DialogContent>
    </Dialog>
  )
}
